// @ts-nocheck
import AppBar from '@material-ui/core/AppBar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import DevicesOtherOutlined from '@material-ui/icons/DevicesOther';
import TuneIcon from '@material-ui/icons/Tune';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Field, change, reduxForm, touch } from 'redux-form';
import { GREEN, GATEWAYS_NOTIFICATION_STATUSES, POWER_CONTROL_UNIT_STATE } from '../../_config/consts';
import * as AccessoriesActions from '../../redux/actions/accessories.actions';
import * as GatewaysActions from '../../redux/actions/gateways.actions';
import * as PowerControlUnitsActions from '../../redux/actions/powerControlUnits.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import CustomField from '../forms/Fields/CustomField.jsx';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import ChartMultilineIconCustom from '../CustomIcons/ChartMultilineIconCustom.jsx';
import SmartLocksEventsIconCustom from '../CustomIcons/SmartLocksEventsIconCustom.jsx';
import MDSwitchView from '../forms/Fields/MDSwitch/MDSwitchView.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import PowerControlUnitAutomationView from './PowerControlUnitAutomationView.jsx';
import PowerControlUnitConsumptionView from './PowerControlUnitConsumptionView.jsx';
import PowerControlUnitHardwareDevicesView from './PowerControlUnitHardwareDevicesView.jsx';
import PowerControlUnitHistoryView from './PowerControlUnitHistoryView.jsx';
import GatewayChip from './GatewayChip.jsx';
import { getPcuGatewayDisplay } from './powerControlUnitGatewayUtils.js';
import PowerStatusBadge from './PowerStatusBadge.jsx';

const POWER_COMMAND_UI_STATUS = {
  PENDING: 'PENDING',
};

const NOTIFICATION_POLLING_INTERVAL_MS = 2000;
const NOTIFICATION_POLLING_TIMEOUT_MS = 60000;

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  }
  return errors;
};

@reduxForm({ form: 'PowerControlUnitDetailsForm', validate })
@connect(state => ({
  selectedPCU: state.powerControlUnits.selectedPCU,
  accessories: state.accessories.data.content,
  form: state.form.PowerControlUnitDetailsForm,
  consumptionForm: state.form.PowerControlUnitConsumptionForm,
}))
class PowerControlUnitDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      isGettingLocation: false,
      powerCommandStatus: null,
    };
  }

  async componentDidMount() {
    const { selectedPCU, accessories, dispatch } = this.props;
    this.init(selectedPCU || {});
    if (_.isEmpty(accessories)) {
      dispatch(AccessoriesActions.fetchAccessories());
    }
  }

  componentWillReceiveProps(nextProps) {
    const { selectedPCU: pcuOld } = this.props;
    const { selectedPCU: pcu } = nextProps;
    const oldId = pcuOld && pcuOld.id;
    const newId = pcu && pcu.id;
    if (newId !== oldId || pcu !== pcuOld) {
      this.init(pcu || {});
      if (newId !== oldId) {
        this.stopNotificationPolling();
        this.setState({ selectedTab: 0, powerCommandStatus: null });
      }
    }
  }

  componentWillUnmount() {
    this.stopNotificationPolling();
  }

  async init(pcu) {
    const { dispatch } = this.props;
    const source = pcu || {};

    dispatch(change('PowerControlUnitDetailsForm', 'name', source.name || ''));
  }

  async onSaveName() {
    const { dispatch, selectedPCU, form } = this.props;
    if (!selectedPCU || !selectedPCU.id) {
      return;
    }
    const detailsValues = form && form.values ? form.values : {};
    const errors = validate(detailsValues);
    if (errors.name) {
      dispatch(touch('PowerControlUnitDetailsForm', 'name'));
      return;
    }
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const result = await dispatch(PowerControlUnitsActions.editPowerControlUnit(
        selectedPCU.id,
        { name: detailsValues.name },
      ));
      dispatch(PowerControlUnitsActions.selectPowerControlUnit(result));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  getGeolocation() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation not supported'));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  }

  onTogglePowerControlUnitState(targetState) {
    const { dispatch, selectedPCU } = this.props;

    if (!selectedPCU || !selectedPCU.id) return;

    const confirmEntity = targetState === POWER_CONTROL_UNIT_STATE.POWER_ON ? 'turnOnConfirm' : 'turnOffConfirm';
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity={confirmEntity} />,
        onConfirmText: <Entity entity="confirm" />,
        onConfirm: () => this.togglePowerControlUnitState(targetState),
        onCancelText: <Entity entity="cancel" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async togglePowerControlUnitState(targetState) {
    const { dispatch, selectedPCU } = this.props;

    dispatch(ModalActions.hideModal());
    dispatch(UtilsActions.setSpinnerVisibile(true));

    let lat;
    let lng;

    if (targetState === POWER_CONTROL_UNIT_STATE.POWER_ON && selectedPCU.geolocationCheck) {
      this.setState({ isGettingLocation: true });
      try {
        const location = await this.getGeolocation();
        lat = location.lat;
        lng = location.lng;
      } catch (error) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="geolocationDenied" /></h6>),
          },
        }));
        return;
      } finally {
        this.setState({ isGettingLocation: false });
      }
    }

    try {
      const actuateResult = await dispatch(PowerControlUnitsActions.sendPowerCommand(selectedPCU.id, targetState, lat, lng));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      const notificationId = actuateResult && actuateResult.gatewayNotificationId;
      const { gatewayId } = getPcuGatewayDisplay(selectedPCU);
      if (notificationId && gatewayId) {
        this.onPollingForNotificationResponse(selectedPCU.id, gatewayId, notificationId);
      } else {
        this.refreshPowerControlUnit(selectedPCU.id);
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      const errorMessage = error && error.message && error.message.includes('range') ? 'geolocationOutOfRange' : 'commandFailed';
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }

  onPollingForNotificationResponse(pcuId, gatewayId, notificationId) {
    const { dispatch } = this.props;
    this.stopNotificationPolling();
    this.setState({ powerCommandStatus: POWER_COMMAND_UI_STATUS.PENDING });
    const timeStart = moment().valueOf();
    this.notificationPollingInterval = setInterval(async () => {
      try {
        const notification = await dispatch(GatewaysActions.getGatewayNotificationDetails(gatewayId, notificationId));
        const isCompleted = notification.status === GATEWAYS_NOTIFICATION_STATUSES.APPLIED || notification.status === GATEWAYS_NOTIFICATION_STATUSES.FAILED;
        const isTimedOut = moment().diff(timeStart) >= NOTIFICATION_POLLING_TIMEOUT_MS;
        if (!isCompleted && !isTimedOut) return;
        this.onNotificationPollingEnd(pcuId);
        if (notification.status === GATEWAYS_NOTIFICATION_STATUSES.FAILED) {
          dispatch(ModalActions.showModal({
            modalType: 'ERROR_ALERT',
            modalProps: {
              message: (<h6 className="snack-title"><Entity entity="commandFailed" /></h6>),
            },
          }));
        }
      } catch (error) {
        this.onNotificationPollingEnd(pcuId);
      }
    }, NOTIFICATION_POLLING_INTERVAL_MS);
  }

  onNotificationPollingEnd(pcuId) {
    this.stopNotificationPolling();
    this.setState({ powerCommandStatus: null });
    this.refreshPowerControlUnit(pcuId);
  }

  stopNotificationPolling() {
    if (this.notificationPollingInterval) {
      clearInterval(this.notificationPollingInterval);
      this.notificationPollingInterval = null;
    }
  }

  async refreshPowerControlUnit(pcuId) {
    const { dispatch } = this.props;
    try {
      const pcu = await dispatch(PowerControlUnitsActions.fetchPowerControlUnit(pcuId));
      dispatch(PowerControlUnitsActions.selectPowerControlUnit(pcu));
      dispatch(PowerControlUnitsActions.updatePowerControlUnitOnState(pcu));
    } catch (error) {
    }
  }

  onSubmitMerged(automationValues) {
    const { onSubmit, form, dispatch, selectedPCU, consumptionForm } = this.props;
    const detailsValues = form && form.values ? form.values : {};
    const errors = validate(detailsValues);
    if (errors.name) {
      dispatch(touch('PowerControlUnitDetailsForm', 'name'));
      return;
    }
    const isCreate = !selectedPCU || !selectedPCU.id;
    const consumptionValues = isCreate && consumptionForm && consumptionForm.values
      ? consumptionForm.values
      : {};
    if (onSubmit) {
      onSubmit({
        ...detailsValues,
        ...consumptionValues,
        ...automationValues,
      });
    }
  }

  onSelectTab(tabIndex) {
    this.setState({ selectedTab: tabIndex });
  }

  onGatewayClick(gatewayId) {
    const { dispatch } = this.props;
    dispatch(push(`/gateways?gatewayId=${gatewayId}`));
  }

  onLockClick(lockId) {
    const { dispatch } = this.props;
    dispatch(push(`/locks?lockId=${lockId}`));
  }

  renderGatewayChip(selectedPCU) {
    const { label, gatewayId } = getPcuGatewayDisplay(selectedPCU);
    return (
      <GatewayChip
        label={label}
        gatewayId={gatewayId}
        onClick={gatewayId => this.onGatewayClick(gatewayId)}
      />
    );
  }

  formatTimestamp(timestamp) {
    if (!timestamp) return '-';
    return moment(timestamp).format('DD/MM/YYYY HH:mm:ss');
  }

  render() {
    const { formStyle, selectedPCU } = this.props;
    const { selectedTab, isGettingLocation, powerCommandStatus } = this.state;
    const isPowerCommandPending = powerCommandStatus === POWER_COMMAND_UI_STATUS.PENDING;

    const isEdit = selectedPCU && selectedPCU.id;

    const isPowered = !!selectedPCU && (
      selectedPCU.state === POWER_CONTROL_UNIT_STATE.POWER_ON
      || selectedPCU.state === POWER_CONTROL_UNIT_STATE.GRACE_PERIOD
    );
    // Units in any other state (e.g. INHIBITED) can't be switched manually
    const canTogglePower = isPowered || (!!selectedPCU && selectedPCU.state === POWER_CONTROL_UNIT_STATE.POWER_OFF);
    const switchTitleStyle = { fontSize: 15, fontWeight: 'bold', color: '#3f3f3f' };

    const sectionRowStyle = {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 10,
      marginBottom: 15,

    };

    const { hasGateway: pcuHasGateway } = getPcuGatewayDisplay(selectedPCU);

    return (
      <div style={{ ...formStyle, padding: 10, paddingTop: 0 }}>
        <FormFlatContainer containerStyle={{ marginRight: 10, marginTop: 0 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', }}>
            <Entity
              componentClass={Field}
              name="name"
              componentAttribute="placeholder"
              entity="insertName"
              title={<Entity entity="name" />}
              component={CustomField}
              mandatory
              containerStyle={{ flex: 1, minWidth: 200, marginBottom: 0 }}
            />
            {isEdit && (
              <MDButton
                title={<Entity entity="save" />}
                backgroundColor={GREEN}
                containerStyle={{ minWidth: 100, marginBottom: 0, marginTop: 15 }}
                style={{ height: 40 }}
                onClick={() => this.onSaveName()}
              />
            )}
          </div>

          {isEdit && (
            <div style={{ marginTop: 20 }}>
              {pcuHasGateway ? (
                  <div style={{ marginBottom: 15 }}>
                    <h5 style={{ fontWeight: 'bold', fontSize: 16, color: '#3f3f3f', marginBottom: 8 }}>
                      <Entity entity="controllingGateway" />
                    </h5>
                    {this.renderGatewayChip(selectedPCU)}
                  </div>
                ) : null}

              {selectedPCU.state && (
                <div style={sectionRowStyle}>
                  <div>
                    <h5 style={{ fontWeight: 'bold', fontSize: 16, color: '#3f3f3f', marginBottom: 8 }}>
                      <Entity entity="currentState" />
                    </h5>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <PowerStatusBadge state={selectedPCU.state} />
                      {isPowerCommandPending && <CircularProgress size={16} thickness={5} />}
                    </div>
                    {selectedPCU.stateUpdatedAt && (
                      <h5 style={{ marginTop: 8, margin: 0, fontSize: 13, color: '#666' }}>
                        <Entity entity="lastUpdated" />: {this.formatTimestamp(selectedPCU.stateUpdatedAt)}
                      </h5>
                    )}
                  </div>
                  <MDSwitchView
                    checked={isPowered}
                    disabled={!canTogglePower || isGettingLocation || isPowerCommandPending}
                    label={<Entity entity={isPowered ? 'powerOn' : 'powerOff'} key={`powerSwitch-${isPowered}`} />}
                    titleStyle={switchTitleStyle}
                    containerStyle={{ marginLeft: 15, marginTop: 28 }}
                    onSelect={turnOn => this.onTogglePowerControlUnitState(turnOn ? POWER_CONTROL_UNIT_STATE.POWER_ON : POWER_CONTROL_UNIT_STATE.POWER_OFF)}
                  />
                </div>
              )}
            </div>
          )}
        </FormFlatContainer>

        {isEdit && (
          <AppBar position="sticky" color="default" style={{ marginTop: 20 }}>
            <Tabs
              value={selectedTab}
              textColor="primary"
              indicatorColor="primary"
              scrollable
              style={{ paddingLeft: 15 }}
              TabIndicatorProps={{
                style: { display: 'none' },
              }}
              onChange={(e, index) => this.onSelectTab(index)}
            >
              <Tab
                icon={<DevicesOtherOutlined style={{ fontSize: 26 }} />}
                label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="hardwareDevices" /></h5>}
              />
              <Tab
                icon={<TuneIcon style={{ fontSize: 26 }} />}
                label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="automationRules" /></h5>}
              />
              <Tab
                icon={<ChartMultilineIconCustom style={{ width: 26 }} />}
                label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="consumptionSettings" /></h5>}
              />
              <Tab
                icon={<SmartLocksEventsIconCustom style={{ width: 26 }} />}
                label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="eventHistory" /></h5>}
              />
            </Tabs>
          </AppBar>
        )}

        <div style={{ paddingLeft: 0, paddingRight: 0, marginTop: 10 }}>
          {!isEdit && (
            <div>
              <PowerControlUnitAutomationView onSubmit={(automationValues) => this.onSubmitMerged(automationValues)} />
              <PowerControlUnitConsumptionView isEdit={false} />
            </div>
          )}
          {isEdit && selectedTab === 0 && (
            <PowerControlUnitHardwareDevicesView
              selectedPCU={selectedPCU}
              onGatewayClick={gatewayId => this.onGatewayClick(gatewayId)}
              onLockClick={lockId => this.onLockClick(lockId)}
            />
          )}
          {isEdit && selectedTab === 1 && (
            <PowerControlUnitAutomationView />
          )}
          {isEdit && selectedTab === 2 && (
            <PowerControlUnitConsumptionView isEdit />
          )}
          {isEdit && selectedTab === 3 && (
            <PowerControlUnitHistoryView />
          )}
        </div>
      </div>
    );
  }
}

export default PowerControlUnitDetailsView;
